(function () {
  var section = document.querySelector('.previa-timeline');
  if (!section) return;

  var track = section.querySelector('.previa-timeline__track');
  var items = Array.prototype.slice.call(section.querySelectorAll('[data-progress]'));
  if (!track || !items.length) return;

  // This theme (Shopify Horizon) scrolls an internal ".page-wrapper" container
  // instead of the window/document, so a listener on `window` alone never fires
  // as the user scrolls. Find whichever element actually scrolls and listen there too.
  function findScrollContainer() {
    var el = section.parentElement;
    while (el && el !== document.body) {
      var cs = window.getComputedStyle(el);
      if ((cs.overflowY === 'auto' || cs.overflowY === 'scroll') && el.scrollHeight > el.clientHeight + 1) {
        return el;
      }
      el = el.parentElement;
    }
    var pageWrapper = document.querySelector('.page-wrapper');
    if (pageWrapper && pageWrapper.scrollHeight > pageWrapper.clientHeight + 1) {
      return pageWrapper;
    }
    return window;
  }

  var scrollContainer = findScrollContainer();
  var ticking = false;
  var mobileQuery = window.matchMedia('(max-width: 860px)');

  function update() {
    ticking = false;
    var rect = track.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var total = rect.height + vh;
    var scrolled = vh - rect.top;
    var progress = total > 0 ? scrolled / total : 0;
    if (progress < 0) progress = 0;
    if (progress > 1) progress = 1;

    var isMobile = mobileQuery.matches;
    items.forEach(function (item) {
      var attr = isMobile ? 'data-m-progress' : 'data-progress';
      var thresh = parseFloat(item.getAttribute(attr)) || 0;
      if (progress >= thresh) {
        item.classList.add('is-visible');
      } else {
        item.classList.remove('is-visible');
      }
    });
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  scrollContainer.addEventListener('scroll', onScroll, { passive: true });
  if (scrollContainer !== window) {
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  window.addEventListener('resize', onScroll, { passive: true });
  update();
})();
